module.exports = __webpack_public_path__ + "img/product_97.6142f26.webp";